export const DELIVERY_STRINGS: Record<string, [string, string, string]> = {
  'delivery.optionsError': [
    '暫時無法確認電子收票方式，請選擇其他可用方式或稍候再試。',
    'Unable to check electronic ticket delivery. Choose another available method or try again later.',
    '電子チケットの受取方法を確認できません。別の利用可能な方法を選ぶか、しばらくしてからお試しください。',
  ],
  'invoice.donationQueryError': [
    '暫時無法確認捐贈單位，請選擇其他發票方式或稍候再試。',
    'Unable to check the donation recipient. Choose another invoice option or try again later.',
    '寄付先を確認できません。別の請求書の種類を選ぶか、しばらくしてからお試しください。',
  ],
  'notification.pending': ['通知寄送中', 'Sending notification', '通知を送信しています'],
  'notification.retrying': [
    '通知稍後寄出',
    'We will retry sending your notification',
    '後ほど通知の送信を再試行します',
  ],
  'notification.sentEmail': [
    '通知已寄出，請查看信箱',
    'Notification sent. Please check your email',
    '通知を送信しました。メールをご確認ください',
  ],
  'notification.sentSms': [
    '通知已寄出，請查看簡訊',
    'Notification sent. Please check your messages',
    '通知を送信しました。SMSをご確認ください',
  ],
  'notification.failed': [
    '通知未寄出，請洽櫃檯',
    'Notification not sent. Please ask at the counter',
    '通知を送信できませんでした。窓口にお越しください',
  ],
  'notification.unknown': [
    '暫時無法確認通知是否寄出',
    'Unable to confirm whether the notification was sent',
    '通知の送信状況を確認できません',
  ],
  'delivery.emailUnavailable': [
    'Email 收票暫時無法使用',
    'Email tickets are temporarily unavailable',
    'メールでの受け取りは現在ご利用いただけません',
  ],
};
